export default "__VITE_ASSET__EqLhfi4h__"